import { schema } from 'normalizr'

export const ENTITY_APPS = 'apps'

export const appSchema = new schema.Entity(
  ENTITY_APPS,
  {},
{ idAttribute: ({status}) => status.app }
)
